module.exports = __webpack_public_path__ + "assets/img/1591950672923.ff5a926d.png";